import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/serviceReviews', request)
}

export {get}
